module.exports = __webpack_public_path__ + "img/_wirtschaftlichkeit.bd4bc5ce.svg";